import get from 'lodash/get.js';
import find from 'lodash/find.js';
import { createAction } from '../utils/createAction';
import {
  GET_DELIVERY_OPTIONS_SUCCESS,
  GET_DELIVERY_OPTIONS_FAILURE,
  UPDATE_SO_DELIVERY_TIME,
} from './actionTypes';
import { getShippingOptions as getShippingOptionsApi } from '../api/eleanorApi';

// actions
const getDeliveryOptionsSuccess = createAction(GET_DELIVERY_OPTIONS_SUCCESS, 'deliveryOptions');

const getDeliveryOptionsFailure = createAction(GET_DELIVERY_OPTIONS_FAILURE);

export const updateSODeliveryTime = createAction(
  UPDATE_SO_DELIVERY_TIME,
  'deliveryTime',
  'productionLeadTime'
);

// thunks
export const getShippingOptions = (itemId) => (dispatch, getState) => {
  const { cart, thdStoreInfo } = getState();
  const zipCode = cart.zipCode || thdStoreInfo.zipcode;

  return getShippingOptionsApi(itemId, zipCode)
    .then((shippingData) => {
      const deliveries = get(shippingData, 'items[0].deliveries');
      const sth = find(deliveries, (dProduct) => dProduct.delivery === 'sth');

      if (sth) {
        dispatch(getDeliveryOptionsSuccess(sth.shipModes));
      } else {
        throw Error();
      }
    })
    .catch(() => {
      dispatch(getDeliveryOptionsFailure());
    });
};
